import React from 'react';
import SEO from '../components/SEO';
import { Link } from 'react-router-dom';
import RoomHero from '../components/RoomHero';
import RoomOverview from '../components/RoomOverview';
import RoomGallery from '../components/RoomGallery';
import OtherServices from '../components/OtherServices';
import image1 from '../assets/images/king_1.jpg';
import image2 from '../assets/images/king_2.jpg';
import image3 from '../assets/images/king_3.jpg';
import image4 from '../assets/images/king_4.jpg';
import image5 from '../assets/images/king_5.jpg';
import images6 from '../assets/images/accomedation_5.jpg';
import images7 from '../assets/images/accomedation_7.jpg';
import images2 from '../assets/images/accomedation_2.jpg';
import images3 from '../assets/images/accomedation_4.jpg';

const RoomKing = ({ language }) => {
  const title = { en: 'Club Room', am: 'ክለብ ክፍል' };
  const subtitle = { en: 'Relaxed comfort with a king bed', am: 'ምቹ የኪንግ አልጋ ጋር ምንጭ ምቾት' };
  const heroImage = image2;

  const overview = {
    en: 'Our Club Rooms provide a comfortable king-size bed with all essential amenities for a restful stay, ideal for solo travelers or couples looking for extra comfort and value.',
    am: 'የክለብ ክፍሎቻችን ለምቾት እና ለማረፍ የሚረዱ አስፈላጊ መሳሪያዎች ጋር ምቹ የኪንግ አልጋን ያቀርባሉ። ለብቻቸው የሚጓዙ ወይም ለተጨማሪ ምቾት የሚመኙ እንግዶች ጥሩ ምርጫ ናቸው።'
  };

  const highlights = [
    { en: 'Comfortable king-size bed', am: 'ምቹ የኪንግ አልጋ' },
    { en: 'Smart TV and complimentary Wi‑Fi', am: 'ስማርት ቲቪ እና ነፃ ዋይ-ፋይ' },
    { en: 'Air conditioning and hot shower', am: 'ኤር ኮንዲሽነር እና ትኩስ ውሃ መታጠቢያ' },
    { en: 'Wardrobe and bedside charging', am: 'የክምችት ማስቀመጫ እና በአልጋ ዳር ማስከተል' },
    { en: 'Accommodation includes breakfast and hotel amenities', am: 'መመዝገቢያው ቁርስን እና የሆቴሉን አመናካኝ አገልግሎቶችን ያካትታል' }
  ];

  const galleryTitle = { en: 'King Room Gallery', am: 'የኪንግ ክፍል ጋለሪ' };
  const images = [image1, image2, image3, image4, image5, images6, images7, images2, images3];

  return (
    <>
      <SEO
        title="Standard King Room"
        description="Relax in our Standard King Room at Blue Nest Hotel. Generous king bed and essential amenities for a restful stay."
        url="/rooms/king"
      />
      <RoomHero title={title} subtitle={subtitle} image={heroImage} language={language} />
      <RoomOverview language={language} overview={overview} highlights={highlights} />
      <div className="container my-4 text-center">
        <Link to="/contact" className="text-decoration-none">
          <button className="room-cta-btn">
            {language === 'am' ? 'ይዘዙ ክፍል' : 'Reserve this Room'}
          </button>
        </Link>
      </div>
      <RoomGallery language={language} title={galleryTitle} images={images} />
      <OtherServices language={language} />
    </>
  );
};

export default RoomKing;
